<template>

<div>
   <b-navbar toggleable  class="header">
     <div class="container">
        <b-navbar-toggle target="nav_text_collapse">
          <i class="material-icons">menu</i>
        </b-navbar-toggle>

        <b-navbar-brand>

          <router-link :to="{name:'dashboard'}" class="navbar-brand">
            <img src="../assets/logo.png" class="logo">
          </router-link>
        </b-navbar-brand>


        <b-collapse is-nav id="nav_text_collapse">
            <b-navbar-nav>


                <li class="nav-item ">
                  <router-link class="nav-link" :to="{name:'dashboard'}">{{$t('header.dashboard')}}</router-link>
                </li>


                <li class="nav-item">
                <b-dropdown id="" text="Administación" class="m-md-2 box-dropdown">

                  <b-dropdown-item :to="{name:'approvePurchase'}">Administar Compras</b-dropdown-item>

                  <b-dropdown-item :to="{name:'approveConsignment'}" >Administar Consignaciones</b-dropdown-item>

                  <b-dropdown-item :to="{name:'companies'}" >Empresas</b-dropdown-item>

                  <!--b-dropdown-item :to="{name:'debt'}" >Cartera</b-dropdown-item-->
                  <b-dropdown-item v-b-modal.uploadFileModal>Subir Archivos</b-dropdown-item>
                  
                </b-dropdown>
                </li>






                <li class="nav-item ">
                  <router-link class="nav-link" :to="{name:'consignment'}">{{$t('header.consignment')}}</router-link>
                </li>

                <li class="nav-item ">
                  <router-link class="nav-link" :to="{name:'buy'}">{{$t('header.buy')}}</router-link>
                </li>

                <li class="nav-item ">
                  <router-link class="nav-link" :to="{name:'api'}">{{$t('header.api')}}</router-link>
                </li>




              
            </b-navbar-nav>
            </b-collapse>
          
            <div class="navbar-text">

              <template v-if="user">
                <div class="balance">
                  ${{money(user.balance)}}
                </div>

                <router-link to="configs" class="btn btn-sm btn-space btn-primary">{{$t('header.settings')}}</router-link>
                <a class="btn btn-sm btn-space btn-secondary" v-on:click="logout">{{$t('header.logout')}}</a>
              </template>
                            
                <template v-else>
                    <router-link to="login" class="btn  btn-space btn-sm btn-primary">Login</router-link>

                </template>

                <template v-if="$i18n.locale == 'es'">
                   <button @click="$i18n.locale = 'en'" class="btn btn-lang btn-sm btn-lang">EN</button>
                </template>
                <template v-else>
                   <button @click="$i18n.locale = 'es'" class="btn btn-lang btn-sm btn-lang">ES</button>
                </template>

                
            </div>
       </div>
          
    </b-navbar>


    <b-modal id="uploadFileModal" ref="uploadFileModal" title="Subir archivos" hide-footer>
      <form v-on:submit.prevent="upload" ref="uploadFileForm">
        <div class="form-group">
          <select class="form-control" name="bankId">
            <option v-for="(bank, index) in banks" :key="index" :value="bank.id">{{bank.name}}</option>
          </select>
        </div>

        <div class="form-group">
          <input type="file" name="file">
        </div>

        <button class="btn btn-primary">Subir archivos</button>
      </form>
    </b-modal>

</div>




</template>


<script>
import { UPLOAD_FILE, FETCH_BANKS } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "app-header",

  methods: {
    logout: function() {
      this.$router.replace("/");
    },
    upload: function() {
      var formData = new FormData(this.$refs.uploadFileForm);
      this.$store
        .dispatch(UPLOAD_FILE, formData)
        .then(result => {
          this.$refs.uploadFileModal.hide();
          this.$snotify.success(result.message);
        })
        .catch(err => {
          this.$snotify.error(err.message);
        });
    }
  },

  mounted() {
    this.$store.dispatch(FETCH_BANKS);
  },

  computed: {
    ...mapGetters(["user", "banks"])
  }
};
</script>


<style lang="scss">
</style>
